const HybridWar = require('./HybridWar');
const WarOverCulture = require('./WarOverCulture');
const WarOverTechnology = require('./WarOverTechnology');
const WarOverTerritory = require('./WarOverTerritory');

module.exports = {
    HybridWar,
    WarOverCulture,
    WarOverTechnology,
    WarOverTerritory
}